import { connect } from 'react-redux';
import { compose } from 'redux';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { selectLandingData } from 'containers/Landing/selectors';
import saga from 'containers/Landing/saga';
import { fetchPageRequest } from 'containers/Landing/actions';
import { LANDING_PAGE_KEY, pages } from 'containers/Landing/constants';
import withContentful from 'containers/Landing/withContenfull';
import CoffeeService from './CoffeeService';

const mapDispatchToProps = {
  fetchPage: fetchPageRequest,
};

const mapStateToProps = createStructuredSelector({
  site: selectLandingData(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = injectSaga({
  key: LANDING_PAGE_KEY,
  saga,
});

export default compose(
  withConnect,
  withSaga,
  withContentful(pages.coffeeService),
)(CoffeeService);
